/* hgn-recorder.js v2026-10-19.2: the site-wide behaviour recorder (our own Clarity, joined to orders).
   Contract: redesigned/RECORDER-CONTRACT-SITE-2026-10-19.md (v1.1). Paste: redesigned/SITE-RECORDER-PASTE-2026-10.md.
   Loaded deferred by snippets/hgn-recorder.liquid (layout/theme.liquid, end of body) on every theme page except the theme
   editor and /account. Kill switch + sampling: Theme settings > Behaviour recorder.
   - The Meta landing (collection.meta with an arm) is recorded EXACTLY as hgn-lp-recorder.js v2026-10-18.1 records it
     (same tokens, exp/arm/variant, 15 s cadence): the v1 maps below are frozen. If the legacy tag (script[data-hgn-lprec])
     is on the page, the legacy recorder owns the landing and this one stays out.
   - Every other page: page = home|collection|pdp|cart|search|page|blog|other, exp/arm/variant omitted, handle + tpl added,
     a send at 5 s, then every 30 s only when the state changed, on hide and on pagehide (final).
   Records NOTHING until Shopify.customerPrivacy.analyticsProcessingAllowed() is true; with no consent it never sends.
   Tokens only: no text, no typed values or search terms, no keystrokes, no coordinates, no personal data. Never throws. ES5. */
(function (W, D) {
  'use strict';
  function main() {
    if (!D || !D.documentElement || W.__hgnRec) return;
    var H = D.documentElement, N = W.navigator || {}, L = W.location, P = W.performance;
    function T() { try { return Math.round(P.now()); } catch (e) { return 0; } }
    function sf(f) { return function () { try { return f.apply(this, arguments); } catch (e) {} }; }
    function cl(e, s) { try { return e && e.closest ? e.closest(s) : null; } catch (x) { return null; } }
    function mt(e, s) { try { return !!(e && e.matches && e.matches(s)); } catch (x) { return false; } }
    function at(e, a) { return (e && e.getAttribute && e.getAttribute(a)) || ''; }
    function on(t, n, f, o) { try { t.addEventListener(n, f, o || false); } catch (e) {} }
    function qa(s) { try { return D.querySelectorAll(s); } catch (e) { return []; } }
    function shown(e) { return !!(e && e.getClientRects && e.getClientRects().length); }
    /* 'tok:selector|tok:selector' → [[tok, selector], …] (a token never holds a colon; the first one splits) */
    function map(s) { return s.split('|').map(function (x) { var i = x.indexOf(':'); return [x.slice(0, i), x.slice(i + 1)]; }); }

    var SC = D.currentScript || D.querySelector('script[data-hgn-rec]');
    var ARM = at(H, 'data-hgn-arm-lp');
    var LPM = at(SC, 'data-lp') === '1' && /^[ABC]$/.test(ARM); /* the Meta landing: v1, frozen */
    /* the landing's own switches: the legacy tag (rollback) owns it; the section's "off" marker stops it */
    if (LPM && D.querySelector('script[data-hgn-lprec],[data-hgn-rec-off]')) return;
    W.__hgnRec = 1;
    var PAGE = LPM ? 'lp' : at(SC, 'data-page') || 'other';
    var LP = W.__hgnLp || {};
    var EXP = String(LP.exp || at(SC, 'data-exp')), KEY = String(LP.key || at(SC, 'data-key'));
    var COLL = at(SC, 'data-coll') || (/\/collections\/([a-z0-9-]+)/.exec(L.pathname) || [])[1] || '';
    var HANDLE = at(SC, 'data-handle'), TPL = at(SC, 'data-tpl').toLowerCase().replace(/-/g, '_').slice(0, 24);
    if (!/^[a-z0-9-]{1,120}$/.test(HANDLE)) HANDLE = '';
    if (!/^[a-z][a-z0-9_]{0,23}$/.test(TPL)) TPL = '';
    var SAMPLE = parseInt(at(SC, 'data-sample'), 10);
    if (isNaN(SAMPLE)) SAMPLE = 100;
    var EP = 'https://track.holygrailnail.com/r';
    var EVERY = Math.max(1000, (LPM ? +W.HGN_LPREC_MS : +W.HGN_REC_MS) || (LPM ? 15000 : 30000));
    var UA = N.userAgent || '';

    /* ── Clarity tags, the landing only (as hgn-lp-recorder.js): every arm, whatever our gate says. Never defines
       window.clarity: the popup's loader skips Clarity when it already exists. ── */
    if (LPM) {
      var clOK = 0;
      var clar = sf(function () {
        if (clOK || typeof W.clarity !== 'function') return;
        clOK = 1;
        W.clarity('set', 'lp_arm', ARM);
        if (KEY) W.clarity('set', 'lp_concept', KEY);
        if (COLL) W.clarity('set', 'lp_coll', COLL);
      });
      var clLater = function () { setTimeout(clar, 0); };
      clar();
      if (!clOK) {
        on(W, 'load', clLater);
        ['pointermove', 'touchstart', 'scroll', 'keydown'].forEach(function (n) { on(W, n, clLater, { once: true, passive: true, capture: true }); });
        on(D, 'visitorConsentCollected', clLater);
        var clN = 0, clI = setInterval(function () { clar(); if (clOK || ++clN >= 300) clearInterval(clI); }, 2000);
      }
    }

    /* ── state ── */
    var REC = 0, GONE = 0, C0 = -1, SEQ = 0, SENDS = 0, PV = '', LASTSIG = '';
    var SEC = {}, VIS = {}, SCR = 0, MAXY = 0, TILES = 0, TAPS = [], NT = 0, TTFT = -1, TOP = 0, EXIT = 'none', OUT = 'none';
    var KS = 0, KP = 0, ATC = 0, LCP = -1, CLS = -1, INP = -1;
    var lastT = T(), visible = D.visibilityState !== 'hidden', lastNav = null, lastTapT = -1e9, lastAdd = -1e9, lastSS = -1e9;
    if (visible) TOP = lastT;
    try { PV = W.crypto && W.crypto.randomUUID ? W.crypto.randomUUID() : ''; } catch (e) {}
    if (!PV) PV = 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
    /* QA: a pinned arm, a theme preview, or (off the landing) a harness browser: the worker drops these rows */
    var PIN = /[?&](hgn_lp_arm|preview_theme_id)=/.test(L.search) || /shopifypreview\.com$/.test(L.hostname) || LP.qa ? 1 : 0;
    var IAB = /Instagram/i.test(UA) ? 'instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A|MessengerForiOS/i.test(UA) ? 'facebook'
      : /musical_ly|BytedanceWebview|TikTok|trill_/i.test(UA) ? 'tiktok' : /; wv\)|Snapchat|Pinterest|Twitter|LinkedInApp|Line\/|GSA\//i.test(UA) ? 'other' : 'none';
    if (!LPM && /HGNApp/.test(UA)) IAB = 'app'; /* our own app (hgn-app-detect's token) */
    var OS = /iPhone|iPad|iPod/.test(UA) || (/Macintosh/.test(UA) && N.maxTouchPoints > 1) ? 'ios' : /Android/.test(UA) ? 'android' : 'other';

    /* ── sections. Order = priority for a tap's section: overlays, sub-areas, then sections. ── */
    var popupO = ['popup', '#hgn-popup', function (e) { return e.classList.contains('is-open'); }, 1];
    var cartO = ['sidecart', '#hgn-side-cart', function (e) { return !e.hidden && at(e, 'aria-hidden') !== 'true'; }, 1];
    var qvO = ['pdp_quick', '[data-hgn-qv-root]', function (e) { return !e.hidden; }, 1];
    var barO = ['kitbar', '[data-hgn-kit-bar]', function (e) { return !e.hidden; }, 0];
    /* Dawn's facets drawer (facets.liquid): its open panel only */
    var drawerO = function (k) { return [k, 'menu-drawer.mobile-facets__wrapper', function (e) { return !!e.querySelector('details.mobile-facets__disclosure[open]'); }, 1, 'menu-drawer details[open] > :not(summary)']; };
    var OV, PG, GRIDS, GRID = '.hgn-bestsellers__grid,#product-grid,.hgn-kit-rail__row';
    if (LPM) { /* v1 (hgn-lp-recorder.js), frozen */
      OV = [popupO, cartO,
        ['lpf_drawer', '[data-hgn-lpf-drawer]', function (e) { return !!e.querySelector('details[open]'); }, 1],
        ['howto_sheet', '[data-hgn-lp-sheet]', function (e) { return !e.hidden; }, 1], qvO, barO];
      if (ARM === 'A') OV.splice(3, 0, drawerO('a_drawer'));
      PG = map(ARM === 'A'
        ? 'a_kitrow:.hgn-coll-kit-group .hgn-ckit-chip,.hgn-coll-kit-group .hgn-ckit-rail|a_kitstrip:.hgn-coll-kit-group|a_filters:[data-hgn-coll-tier1],#main-collection-filters|' +
          'a_hero:[id$="__lpa-hero"]|a_grid:[id$="__lpa-grid"] #product-grid|a_seo:[id$="__lpa-seo"]'
        : 'b_proof:[id$="__lpb-hero"] .hgn-lp-proof|b_howto:[data-hgn-lp-chips]|b_pills:[id$="__lpb-edit"] .hgn-bestsellers__pillrow|b_kitcard:[data-hgn-lp-kitstrip]|' +
          'b_filters:[data-hgn-lpf-panel]|b_more:[id$="__lpb-edit"] .hgn-bestsellers__load-more-wrap,[data-hgn-lpf-results] [data-hgn-lp-feed-handle]|b_results:[data-hgn-lpf-results]|' +
          'b_grid:[id$="__lpb-edit"] [data-hgn-bs-panel]:not([data-hgn-lpf-results])|b_hero:[id$="__lpb-hero"]|b_press:[id$="__lpb-proof"]|b_kits:[id$="__lpb-kits"]|' +
          'b_ranges:[id$="__lpb-ranges"]|b_reviews:[id$="__lpb-reviews"]|b_founder:[id$="__lpb-founder"]|b_quiz:[id$="__lpb-quiz"]')
        .concat(map('announce:section.hgn-announce|header:.hgn-header|footer:[id*="__hgn_footer"]'));
      GRIDS = ARM === 'A' ? '[id$="__lpa-grid"] #product-grid > li' : '[id$="__lpb-edit"] .hgn-bestsellers__grid > *';
    } else { /* v1.1: the site's page types (section maps from the live templates, 19 Oct) */
      OV = [popupO, cartO, drawerO('facets_drawer'), ['pdp_zoom', 'product-modal', function (e) { return e.hasAttribute('open'); }, 1], qvO, barO];
      var pm = {
        home: 'home_hero:.hgn-hero-section|home_press:.hgn-marquee-section|home_ranges:.hgn-quick-links-section|home_quiz:.hgn-quiz-section|home_best:.hgn-bestsellers-section|' +
          'home_kits:.hgn-kit-rail-section|home_ritual:.hgn-ritual-section|home_drop:.hgn-drop-teaser-section|home_founder:.hgn-founder-section|home_reviews:.hgn-reviews-section|' +
          'home_points:.hgn-nail-points-section',
        collection: 'coll_kitrow:.hgn-coll-kit-group .hgn-ckit-chip,.hgn-coll-kit-group .hgn-ckit-rail|coll_kitstrip:.hgn-coll-kit-group|' +
          'coll_filters:[data-hgn-coll-tier1],#main-collection-filters,.facets-wrapper|coll_hero:.hgn-collection-hero|coll_grid:#product-grid|coll_seo:.hgn-cseo',
        pdp: 'pdp_sticky:.hgn-buy-sticky|pdp_kit:.hgn-pdp-kit|pdp_options:variant-selects,variant-radios,.product-form__quantity|pdp_buy:.hgn-buy|pdp_ai:.hgn-ai-hook|' +
          'pdp_howto:.hgn-app-pill,[data-hgn-app-vid]|pdp_trust:.hgn-trust-perf,.hgn-trust-promise,.hgn-we-say,.hgn-style-it-up,.hgn-ctl-card|pdp_info:.hgn-pdp-title,.hgn-pdp-spec,.hgn-price,#hgn-global-stars-trigger|' +
          'pdp_upsell:.hgn-pdp-content__upsells|pdp_details:[data-hgn-pdp-content-piece],.hgn-pdp-content-source|pdp_gallery:media-gallery|pdp_reviews:.hgn-product-reviews|' +
          'pdp_recs:.related-products',
        cart: 'cart_kit:[data-hgn-cart-page-bundle]|cart_shipbar:[data-hgn-cart-page-shipbar]|cart_offers:[data-hgn-cart-page-panels]|cart_lines:[data-hgn-cart-page-items]|' +
          'cart_summary:[data-hgn-cart-page-summary]|cart_empty:.hgn-cart-page__empty|cart_head:.hgn-cart-page__head',
        search: 'search_chips:[data-hgn-sb-chips]|search_bar:.hgn-search-bar|search_supp:.hgn-search-supplement|search_tabs:[data-hgn-tabs]|' +
          'search_filters:[data-hgn-coll-tier1],.hgn-search-grid .facets-wrapper|search_grid:.hgn-search-grid__grid'
      }[PAGE];
      PG = map((pm ? pm + '|' : '') + 'app_bar:.hgn-app-tab-bar|announce:section.hgn-announce|header:.hgn-header|crumbs:.hgn-breadcrumbs|footer:[id*="__hgn_footer"]');
      GRIDS = { home: '.hgn-bestsellers-section .hgn-bestsellers__grid > *', collection: '#product-grid > li', search: '.hgn-search-grid__grid > *', pdp: '.related-products .grid > *' }[PAGE] || '';
      GRID += ',.hgn-search-grid__grid,.related-products .grid';
    }

    function secOf(e) {
      var i, o;
      for (i = 0; i < OV.length; i++) { o = OV[i]; if (cl(e, o[4] || o[1])) return o[0]; }
      for (i = 0; i < PG.length; i++) if (cl(e, PG[i][1])) return PG[i][0];
      return !LPM && cl(e, '#MainContent') ? 'main' : 'none';
    }

    /* ── tap labels: [selector, label, value/index fn or a fixed value]. First rule whose closest() matches wins. ── */
    var TILE = '.card-wrapper,[data-hgn-kit-placed],[data-hgn-lpf-shell],.grid__item,.hgn-kit-rail__card';
    function slug(s) {
      s = String(s || '').toLowerCase().replace(/[^a-z0-9_:.-]+/g, '-').replace(/-+/g, '-').replace(/^[^a-z0-9]+/, '').slice(0, 40);
      return /^[a-z0-9][a-z0-9_:.-]{0,39}$/.test(s) ? s : '';
    }
    function tileOf(e) { var g = cl(e, GRID); if (!g) return null; while (e && e.parentNode !== g) e = e.parentNode; return e; }
    function nth(t, sel) {
      if (!t || !t.parentNode) return 0;
      for (var n = 0, c = t.parentNode.firstElementChild; c; c = c.nextElementSibling) {
        if (mt(c, sel) && shown(c)) n++;
        if (c === t) return n;
      }
      return 0;
    }
    function tier(e) {
      var c = cl(e, '[data-hgn-kit-tier],[data-tier]'), k = cl(e, '.hgn-card'), v = at(c, 'data-hgn-kit-tier') || at(c, 'data-tier');
      if (!/^(press-ons|gels|classic)$/.test(v) && k) v = at(k.querySelector('.wishlist-card-button[data-tier],[data-hgn-card-kit][data-tier]'), 'data-tier');
      return /^(press-ons|gels|classic)$/.test(v) ? v : '';
    }
    function vTile(e) { return { i: nth(tileOf(e), TILE), v: tier(e) }; }
    function vx(sel, a, n) { return function (e) { var x = cl(e, sel); return { i: n ? nth(x, sel) : 0, v: a === 'href' ? range(at(x, a)) : slug(at(x, a)) }; }; }
    function range(h) {
      h = String(h || '');
      return /press-on/.test(h) ? 'press-ons' : /gel-nail|\/gels/.test(h) ? 'gels' : /classic|manicure-wrap/.test(h) ? 'classic'
        : /pedicure/.test(h) ? 'pedicure' : /starter-kit/.test(h) ? 'kits' : /collections\/all/.test(h) ? 'all' : '';
    }
    function fkey(p) { var m = /([a-z0-9_]+)$/.exec(String(p || '').toLowerCase()); return m ? m[1] : ''; }
    function vChip(e) {
      var x = cl(e, '[data-hgn-lpf-chip],[data-hgn-tier1-chip]'), lp = x && x.hasAttribute('data-hgn-lpf-chip');
      var k = fkey(at(x, lp ? 'data-hgn-lpf-param' : 'data-hgn-tier1-param')), v = at(x, lp ? 'data-hgn-lpf-value' : 'data-hgn-tier1-value');
      return { i: nth(x, lp ? '[data-hgn-lpf-chip]' : '[data-hgn-tier1-chip]'), v: k ? slug(k + ':' + v) : '' };
    }
    function vOpt(e) {
      var lab = cl(e, 'label'), inp = mt(e, 'input') ? e : lab && (lab.control || lab.querySelector('input'));
      if (!inp || !/^(checkbox|radio)$/.test(inp.type)) return { v: '' }; /* never a typed value */
      var k = fkey(inp.name);
      return { v: k ? slug(k + ':' + inp.value) : '' };
    }
    function vGroup(e) { var d = cl(e, 'details'); var m = /filter\.[a-z]\.(?:[a-z0-9_]+\.)*([a-z0-9_]+)/.exec(at(d, 'id')); return { v: m ? slug(m[1]) : '' }; }
    function vMore(e) {
      var b = cl(e, '[data-hgn-bs-reveal],[data-hgn-lp-feed-handle],.hgn-bestsellers__load-more'), p = cl(b, '[data-hgn-bs-panel]');
      return { v: p && p.querySelector('[data-hgn-bs-more][hidden]') ? '0' : (at(b, 'data-hgn-lp-feed-next') || '1') };
    }
    function lKit(e) {
      var k = cl(e, '[data-hgn-kit-placed-kind]'), g = cl(e, '[data-hgn-kit-gateway]');
      var shell = cl(e, '[data-hgn-lpf-shell]') || (k ? at(k, 'data-hgn-kit-placed-kind') === 'shell' : (at(g, 'data-shell') === 'true' || !!(g && g.querySelector('[data-hgn-collage-shell]'))));
      return shell ? 'kit_tile' : 'kit_edit_tile';
    }
    /* a PDP option: v = the option's name key (size, shape…) from the input's name, never free text */
    function vVar(e) {
      var lab = cl(e, 'label'), inp = mt(e, 'input,select') ? e : lab && (lab.control || lab.querySelector('input'));
      return { v: slug(fkey(String(at(inp, 'name')).replace(/[\]\s]+/g, '_').replace(/_+$/, ''))) };
    }
    function nthOf(sel) { return function (e) { var x = cl(e, sel); return { i: nth(x, sel) }; }; }
    var LB = [ /* v1 (hgn-lp-recorder.js), frozen: the landing uses only these */
      ['[data-hgn-popup-close],[data-hgn-popup-teaser-close],[data-hgn-popup-reminder-close]', 'popup_close'],
      ['#hgn-popup [data-goal]', 'popup_goal', vx('[data-goal]', 'data-goal')],
      ['[data-hgn-popup-submit],[data-rf-submit-btn]', 'popup_submit'],
      ['[data-hgn-side-cart-checkout],[data-hgn-side-cart-kit-cta],[data-hgn-express-regular]', 'cart_checkout'],
      ['[data-hgn-express-open],[data-hgn-express-wallets],shopify-accelerated-checkout-cart', 'express_pay'],
      ['[data-hgn-side-cart-close],[data-hgn-side-cart-scrim]', 'cart_close'],
      ['[data-hgn-side-cart-upsell]', 'cart_upsell'],
      ['[data-hgn-kit-bar-view]', 'kitbar_checkout'],
      ['[data-hgn-kit-bar-status]', 'kitbar_open'],
      ['[data-hgn-kit-bar-switch]', 'kit_toggle'],
      ['.hgn-qv-trigger', 'qv_open'],
      ['[data-hgn-lp-sheet-shop],[data-hgn-lp-sheet-range]', 'howto_shop', vx('[data-hgn-lp-sheet-range]', 'data-hgn-lp-sheet-range')],
      ['[data-hgn-lp-sheet-close]', 'howto_close'],
      ['[data-hgn-drawer-close]', 'drawer_close'],
      ['.mobile-facets__clear,.mobile-facets__clear-wrapper', 'filter_clear'],
      ['.mobile-facets__footer .button,.mobile-facets__footer [type=submit]', 'drawer_apply'],
      ['.mobile-facets__list label,.mobile-facets__list input', 'drawer_option', vOpt],
      ['.mobile-facets__sort,.mobile-facets__sort select', 'filter_sort'],
      ['.mobile-facets__open-wrapper', 'filter_open'],
      ['.mobile-facets__summary', 'drawer_group', vGroup],
      ['.hgn-header__menu-trigger', 'hdr_menu'],
      ['.hgn-header__logo', 'hdr_logo'],
      ['[data-hgn-search-toggle],.hgn-header__search-strip', 'hdr_search'],
      ['.wishlist-header-wrapper', 'hdr_wish'],
      ['[data-hgn-cart-trigger]', 'hdr_cart'],
      ['.hgn-header__nav-link,.hgn-header__mobile-link', 'nav_link', vx('.hgn-header__nav-link,.hgn-header__mobile-link', 'href', 1)],
      ['.hgn-hero__ctas a', 'hero_cta'],
      ['.hgn-hero__image,.hgn-hero__img', 'hero_img'],
      ['.hgn-hero__headline', 'hero_headline'],
      ['.hgn-lp-proof__face,[data-hgn-lp-faces]', 'proof_faces'],
      ['.hgn-lp-proof__l2,.hgn-hero__trust,.hgn-lp-offer', 'trust_line'],
      ['.hgn-lp-proof', 'proof_stars'],
      ['[data-hgn-lp-chip="how-to-apply"]', 'howto_open'],
      ['[data-hgn-lp-chip]', 'howto_chip', vx('[data-hgn-lp-chip]', 'data-hgn-lp-chip', 1)],
      ['[data-hgn-lpf-open]', 'filter_open'],
      ['[data-hgn-lpf-range]', 'range_pill', vx('[data-hgn-lpf-range]', 'data-hgn-lpf-range', 1)],
      ['[data-hgn-bs-tab]', 'range_pill', vx('[data-hgn-bs-tab]', 'data-hgn-bs-tab', 1)],
      ['[data-hgn-lpf-active] a,[data-hgn-lpf-active] button,.active-facets a', 'filter_remove'],
      ['[data-hgn-lpf-clear],.hgn-coll-clear-all', 'filter_clear'],
      ['[data-hgn-lpf-sort],.hgn-coll-sort-toggle,.facet-filters__sort', 'filter_sort'],
      ['[data-hgn-lpf-chip],[data-hgn-tier1-chip]', 'filter_chip', vChip],
      ['[data-hgn-lp-kitstrip-switch]', function (e) { return at(cl(e, '[data-hgn-lp-kitstrip-switch]'), 'aria-pressed') === 'true' ? 'kitcard_stop' : 'kitcard_start'; }, vx('[data-hgn-lp-kitstrip]', 'data-hgn-lp-kitstrip')],
      ['[data-hgn-coll-kit-help]', 'kit_help'],
      ['[data-hgn-coll-kit-toggle],.hgn-coll-kit-seg', 'kit_toggle'],
      ['.hgn-ckit-chip', 'kitrow_view', vx('.hgn-ckit-chip', 'data-hgn-ckit-view')],
      ['[data-hgn-kr-tab]', 'kitrail_tab', vx('[data-hgn-kr-tab]', 'data-hgn-kr-tab')],
      ['.hgn-kit-rail__card', 'kitrail_card', vx('.hgn-kit-rail__card', '', 1)],
      ['[data-hgn-kit-placed],[data-hgn-lpf-shell],[data-hgn-kit-gateway]', lKit, vTile],
      ['.hgn-card__quickadd.is-kit-takeover,[data-hgn-card-kit]', 'kit_pick', vTile],
      ['.hgn-card__wishlist,.wishlist-card-button', 'card_wish', vTile],
      ['.hgn-card__quickadd,.quick-add__submit', 'card_add', vTile],
      ['.image-cycling-indicators,.image-cycling-arrow', 'card_swipe', vTile],
      ['.hgn-card__media,.card__media', 'card_img', vTile],
      ['.hgn-card__name', 'card_name', vTile],
      ['.hgn-card__price,.hgn-card .price', 'card_price', vTile],
      ['.hgn-card', 'card_body', vTile],
      ['[data-hgn-bs-reveal],[data-hgn-lp-feed-handle],.hgn-bestsellers__load-more', 'load_more', vMore],
      ['.hgn-marquee__logo,.hgn-marquee__pub,.hgn-marquee__stat', 'press_logo'],
      ['.hgn-quick-link', 'range_tile', vx('.hgn-quick-link', 'href', 1)],
      ['.hgn-review-card', 'review_card', vx('.hgn-review-card', '', 1)],
      ['.hgn-reviews__foot a,[id$="__lpb-reviews"] .hgn-link-underline', 'reviews_all'],
      ['.hgn-founder__cta', 'founder_cta'],
      ['.hgn-quiz__cta,[data-hgn-quiz-open]', 'quiz_cta'],
      ['[data-hgn-collection-hero-toggle]', 'a_readmore'],
      ['[id*="__hgn_footer"] a', 'footer_link']
    ];
    /* v1.1: the site's own elements, checked before the v1 rules (never on the landing) */
    if (!LPM) LB = [
      /* carts (side cart and /cart) */
      ['[data-hgn-side-cart-action="inc"],[data-hgn-cart-page-qty-inc]', 'cart_qty', 'inc'],
      ['[data-hgn-side-cart-action="dec"],[data-hgn-cart-page-qty-dec]', 'cart_qty', 'dec'],
      ['[data-hgn-side-cart-action="remove-bundle"],[data-hgn-cart-page-bundle-remove]', 'cart_remove', 'kit'],
      ['[data-hgn-side-cart-action="remove"],[data-hgn-cart-page-line-remove]', 'cart_remove', 'line'],
      ['[data-hgn-cart-page-checkout]', 'cart_checkout'],
      ['[data-hgn-cart-page-adhoc],[data-hgn-side-cart-adhoc-toggle],[data-hgn-side-cart-adhoc-summary],[data-hgn-side-cart-adhoc-body]', 'cart_code'],
      ['[data-hgn-cart-page-beans],[data-hgn-side-cart-beans]', 'cart_points'],
      /* search: the header panel and /search (never a term: chips and suggestions carry no value) */
      ['[data-hgn-search-item],.hgn-header__search-product', 'search_result', nthOf('[data-hgn-search-item],.hgn-header__search-product')],
      ['.hgn-header__search-suggestion', 'search_suggest'],
      ['[data-hgn-search-input],.hgn-sb__input', 'search_input'],
      ['.hgn-sb__submit,.hgn-header__search-form [type=submit]', 'search_submit'],
      ['.hgn-sb__chip', 'search_chip', nthOf('.hgn-sb__chip')],
      ['.hgn-search-grid__tab', 'search_tab', vx('.hgn-search-grid__tab', 'data-hgn-tab', 1)],
      /* the PDP (dead taps on its title, price, trust and stars take the section token) */
      ['.hgn-buy__submit.is-kit-takeover,[data-hgn-buy-sticky-cta].is-kit-takeover', 'pdp_kit_add'],
      ['[data-hgn-buy-submit],.product-form__submit,[data-hgn-buy-sticky-cta]', 'pdp_atc'],
      ['[data-hgn-notify-submit]', 'pdp_notify'],
      ['[data-hgn-buy-wish]', 'pdp_wish'],
      ['.quantity__button[name=plus]', 'pdp_qty', 'inc'],
      ['.quantity__button', 'pdp_qty', 'dec'],
      ['variant-selects,variant-radios', 'pdp_variant', vVar],
      ['media-gallery .slider-button', 'pdp_gallery_nav'],
      ['.thumbnail-list__item', 'pdp_thumb', nthOf('.thumbnail-list__item')],
      ['.product__modal-opener,.product__media-toggle', 'pdp_zoom', nthOf('.product__media-item')],
      ['.hgn-ai-hook', 'ai_hook'],
      ['[data-hgn-av-prev],[data-hgn-av-next],[data-hgn-av-dot],[data-hgn-av-step]', 'howto_nav'],
      ['.hgn-app-pill,[data-hgn-app-pill]', 'app_pill'],
      ['[data-hgn-pdp-content-atc]', 'pdp_upsell_add'],
      ['.hgn-pdp-content__row-summary', 'pdp_row', function (e) { return { v: slug(at(cl(e, '[data-hgn-pdp-content-piece]'), 'data-content-type')) }; }],
      ['#hgn-global-stars-trigger', 'review_stars'],
      ['[data-hgn-pr-write]', 'reviews_write'],
      ['[data-hgn-pr-more]', 'reviews_more'],
      ['.hgn-product-reviews__list > *', 'review_card', nthOf('.hgn-product-reviews__list > *')],
      /* the homepage */
      ['.hgn-hero__ctas .hgn-btn-ghost', 'hero_ghost'],
      ['[data-tier-tab]', 'ritual_tab', nthOf('[data-tier-tab]')],
      ['.hgn-ritual__cta', 'ritual_cta', vx('.hgn-ritual__cta', 'data-hgn-ritual-tier')],
      ['[data-tier-prev],[data-tier-next],[data-tier-dot],[data-tier-step]', 'ritual_nav'],
      ['.hgn-drop-flag__card', 'drop_card', vx('.hgn-drop-flag__card', 'data-hgn-drop-teaser-tier', 1)],
      ['.hgn-drop-flag__cta', 'drop_cta'],
      ['.hgn-nail-points__cta', 'points_cta'],
      ['.hgn-bestsellers__head a', 'best_all'],
      ['.hgn-kit-rail__all', 'kitrail_all', vx('.hgn-kit-rail__all', 'href')],
      /* collections, and our app's tab bar */
      ['[data-hgn-collection-hero-toggle]', 'coll_readmore'],
      ['[data-hgn-card-drop]', 'drop_pick', vTile],
      ['.hgn-app-tab-bar__tab', 'app_tab', vx('.hgn-app-tab-bar__tab', 'data-hgn-tab')]
    ].concat(LB);
    var INTER = 'a,button,input,select,textarea,label,summary,[role=button],[role=tab],[role=link],[role=checkbox],[role=switch],[tabindex]:not([tabindex^="-"]),' +
      '[data-hgn-lp-sheet-close],[data-hgn-side-cart-scrim],[data-hgn-kit-swap-cancel],[data-hgn-kit-focus-cancel],[data-hgn-kit-off-cancel]';
    var BACKDROP = 'form.mobile-facets,details.mobile-facets__disclosure[open]';
    var NAVL = { cart_checkout: 1, express_pay: 1, search_submit: !LPM };

    function label(e, swipe) {
      var r = { l: '', i: 0, v: '' }, j, x, o;
      if (swipe === 2) { r.l = 'pdp_gallery_swipe'; return r; }
      if (swipe) { o = vTile(e); r.l = 'card_swipe'; r.i = o.i; r.v = o.v; return r; }
      if (mt(e, BACKDROP)) { r.l = 'drawer_close'; return r; }
      for (j = 0; j < LB.length; j++) {
        x = LB[j];
        if (!cl(e, x[0])) continue;
        r.l = typeof x[1] === 'function' ? x[1](e) : x[1];
        o = typeof x[2] === 'function' ? x[2](e) || {} : { v: x[2] };
        r.i = o.i || 0; r.v = o.v || '';
        return r;
      }
      x = cl(e, INTER);
      r.l = !x ? '' : mt(x, 'a[href]') ? 'other_link' : 'other_button';
      return r;
    }

    /* ── consent, then (off the landing) the sample: a stable 0–99 bucket per browser, kept after consent only ── */
    /* 20 Oct: quick iPhone bounces left before Shopify's privacy API loaded, so consented views went unrecorded (b6: pdp
       coverage 67%). Until the API exists, read Shopify's own consent cookie (_tracking_consent, the record the API
       itself reads): purposes.a, else con.CMP.a. No cookie or no analytics = no. Once the API loads it decides. */
    function cookieOk() {
      try {
        var m = (D.cookie || '').match(/(?:^|; )_tracking_consent=([^;]*)/); if (!m) return false;
        var j = JSON.parse(decodeURIComponent(m[1]));
        if (!j || j.display_banner === true) return false; /* banner still showing = no decision yet */
        if (j.purposes && typeof j.purposes.a === 'boolean') return j.purposes.a === true;
        var c = j && j.con && j.con.CMP; return !!(c && c.a === '1');
      } catch (e) { return false; }
    }
    function ok() {
      try { var c = W.Shopify && W.Shopify.customerPrivacy; if (c && typeof c.analyticsProcessingAllowed === 'function') return c.analyticsProcessingAllowed() === true; } catch (e) { return false; }
      return cookieOk();
    }
    var SMP = -1;
    function inSample() {
      if (SMP < 0) {
        SMP = 1;
        if (!LPM && SAMPLE < 100) {
          var b = -1;
          try { b = parseInt(W.localStorage.getItem('hgn:rec:b'), 10); if (!(b >= 0 && b < 100)) { b = Math.floor(Math.random() * 100); W.localStorage.setItem('hgn:rec:b', String(b)); } } catch (e) { b = Math.floor(Math.random() * 100); }
          SMP = b < SAMPLE ? 1 : 0;
        }
      }
      return SMP === 1;
    }
    var polls = 0, lf = 0, pollT = 0;
    var gate = sf(function (ev) { if (!REC && ok() && inSample()) start(ev === 1); });
    on(D, 'visitorConsentCollected', function () { setTimeout(function () { gate(1); }, 0); });
    pollT = setInterval(sf(function () {
      if (REC || ++polls > 40) { clearInterval(pollT); return; }
      var S = W.Shopify;
      if (polls === 6 && S && !S.customerPrivacy && typeof S.loadFeatures === 'function' && !lf) {
        lf = 1;
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { gate(0); });
      }
      gate(0);
    }), 500);

    /* ── identity: sc (Shopify's browser id) else cid (_hgn_cid), as hgn-lp-arm's ident() and the pixel. Read only. ── */
    var IDV = /^[A-Za-z0-9_\-.]{8,64}$/, SCV = /^[A-Za-z0-9_\-.]{8,80}$/;
    function ck(n) { var m = (D.cookie || '').match(new RegExp('(?:^|; )' + n + '=([^;]*)')); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
    function stY() {
      try { var st = (P.getEntriesByType('navigation')[0] || {}).serverTiming || []; for (var i = 0; i < st.length; i++) if (st[i].name === '_y') return String(st[i].description || ''); } catch (e) {}
      return '';
    }
    function ids() {
      var s = ck('_shopify_y'); if (!SCV.test(s)) { s = stY(); if (!SCV.test(s)) s = ''; }
      var c = ck('_hgn_cid'); if (!IDV.test(c)) c = '';
      return { sc: s, cid: c, idk: s ? 'sc:' + s : c ? 'cid:' + c : '' };
    }

    /* ── visibility: IntersectionObserver keeps who is on screen; the rule (≥50% of the element, or ≥30% of the
       viewport) is measured for those only, on a 1 s tick and on scroll. ── */
    var REG = [], io = null, tio = null, lastScan = -1e9, tickT = 0, sendT = 0, early = 0;
    function scan() {
      lastScan = T();
      var i, j, k, list, e;
      for (i = REG.length - 1; i >= 0; i--) if (!REG[i].e.isConnected) { if (io) io.unobserve(REG[i].e); REG.splice(i, 1); }
      var defs = OV.concat(PG);
      for (i = 0; i < defs.length; i++) {
        list = qa(defs[i][1]);
        for (j = 0; j < list.length; j++) {
          e = list[j]; k = defs[i][0];
          if (e['__hgnS' + k]) continue;
          e['__hgnS' + k] = 1;
          REG.push({ k: k, e: e, o: defs[i][3] !== undefined ? defs[i] : null });
          if (io) io.observe(e);
        }
      }
      if (tio && GRIDS) { list = qa(GRIDS); for (j = 0; j < list.length; j++) if (!list[j].__hgnU) { list[j].__hgnU = 1; tio.observe(list[j]); } }
    }
    function calc() {
      var vw = W.innerWidth || H.clientWidth, vh = W.innerHeight || H.clientHeight, now = {}, cover = 0, i, r, e, a, b, w, h;
      for (i = 0; i < REG.length; i++) {
        r = REG[i]; e = r.e;
        if (r.o) { if (r.o[2](e)) { now[r.k] = 1; if (r.o[3]) cover = 1; } continue; }
        if (now[r.k] || e.__hgnJ === 0) continue;
        b = e.getBoundingClientRect();
        w = Math.max(0, Math.min(b.right, vw) - Math.max(b.left, 0)); h = Math.max(0, Math.min(b.bottom, vh) - Math.max(b.top, 0));
        a = b.width * b.height;
        if (a > 0 && w * h > 0 && (w * h / a >= 0.5 || w * h >= 0.3 * vw * vh)) now[r.k] = 2;
      }
      if (cover) for (i in now) if (now[i] === 2) delete now[i]; /* a covering overlay pauses the page under it */
      return now;
    }
    var tick = sf(function () {
      var t = T(), dt = t - lastT, k;
      lastT = t;
      if (visible && dt > 0) {
        TOP += dt;
        for (k in VIS) if (SEC[k]) SEC[k][0] += dt;
      }
      if (!REC) return; /* before consent only the time on page moves: nothing is read from the page */
      if (t - lastScan > 2000) scan();
      VIS = calc();
      for (k in VIS) if (!SEC[k]) SEC[k] = [0, t];
      var y = W.pageYOffset || H.scrollTop || 0, vh = W.innerHeight || H.clientHeight, sh = Math.max(H.scrollHeight, D.body ? D.body.scrollHeight : 0);
      if (y + vh > MAXY) MAXY = Math.round(y + vh);
      if (sh > 0) SCR = Math.max(SCR, Math.min(100, Math.round(100 * (y + vh) / sh)));
    });
    var lastScroll = 0;
    function onScroll() { var t = T(); if (t - lastScroll > 250) { lastScroll = t; tick(); } }

    /* ── taps: one delegated passive capture listener; coordinates stay in memory for rage and swipe only ── */
    var down = null, recent = [], burst = 0, pend = [], moOn = 0;
    function interactive(e) { return !!cl(e, INTER) || mt(e, BACKDROP); }
    function noopable(e) {
      var x = cl(e, INTER);
      if (!x || mt(x, 'input,select,textarea,label,[disabled]') || cl(e, 'label')) return false;
      if (!LPM && mt(x, '[type=submit]') && cl(x, 'form[action*="/search"]')) return false; /* a search submit navigates */
      return !(mt(x, 'a[href]') && !/^(#|javascript:|$)/i.test(at(x, 'href')));
    }
    var IGN = 'head,script,style,link,iframe,noscript,meta,[data-hgn-ka-at],.hgn-kit-countdown,[data-hgn-side-cart-timer]';
    function real(n) { return n.nodeType === 1 ? !cl(n, IGN) : n.nodeType === 3 && /\S/.test(n.nodeValue || ''); }
    function effect() { pend = []; if (moOn) { mo.disconnect(); moOn = 0; } }
    var mo = W.MutationObserver ? new MutationObserver(sf(function (list) {
      for (var i = 0, m, j; i < list.length; i++) {
        m = list[i];
        if (cl(m.target.nodeType === 1 ? m.target : m.target.parentNode, IGN)) continue;
        if (m.type !== 'childList') return effect();
        for (j = 0; j < m.addedNodes.length; j++) if (real(m.addedNodes[j])) return effect();
        for (j = 0; j < m.removedNodes.length; j++) if (real(m.removedNodes[j])) return effect();
      }
    })) : null;
    on(W, 'scroll', function () { if (pend.length) effect(); }, { passive: true, capture: true });
    on(W, 'pagehide', effect); on(W, 'beforeunload', effect); on(D, 'visibilitychange', effect);
    var noopCheck = sf(function () {
      var t = T();
      pend = pend.filter(function (p) { if (t < p.d) return true; if (p.tp.k === 'ok') p.tp.k = 'noop'; return false; });
      if (!pend.length) effect();
    });
    var tap = sf(function (e, x, y, swipe) {
      if (!REC) return;
      if (e && e.nodeType !== 1) e = e.parentElement;
      if (!e) return;
      var t = T(), m = label(e, swipe), s = secOf(e), k = swipe || interactive(e) ? 'ok' : 'dead', i, near = 0, tp;
      NT++;
      lastTapT = t;
      if (TTFT < 0) TTFT = t;
      if (!m.l) m.l = s;
      if (!swipe) {
        recent = recent.filter(function (r) { return t - r.t <= 800; });
        for (i = 0; i < recent.length; i++) if (Math.abs(recent[i].x - x) <= 30 && Math.abs(recent[i].y - y) <= 30) near++;
        recent.push({ x: x, y: y, t: t });
        if (near >= 2) { if (burst) return; burst = 1; k = 'rage'; } else burst = 0;
      }
      tp = { l: m.l, s: s, i: m.i, v: m.v, t: t, k: k };
      if (TAPS.length < 50) TAPS.push(tp);
      if (k === 'ok' && !swipe && noopable(e)) {
        pend.push({ tp: tp, d: t + 1000 });
        if (mo && !moOn) { mo.observe(H, { subtree: true, childList: true, attributes: true, characterData: true }); moOn = 1; }
        setTimeout(noopCheck, 1010);
      }
      var a = cl(e, 'a[href]');
      if (NAVL[m.l] || (a && !/^(#|javascript:|$)/i.test(at(a, 'href')))) lastNav = { l: m.l, t: t };
      if (m.l === 'filter_sort') lastSort = tp;
      if (m.l === 'search_submit') lastSS = t;
    });
    var lastSort = null;
    on(D, 'change', sf(function (ev) { /* the sort picked (an option value from the markup) */
      var e = ev.target;
      if (REC && lastSort && mt(e, 'select') && T() - lastSort.t < 60000) lastSort.v = slug(e.value);
    }), true);
    /* a search sent with the keyboard (Enter): the event only, never the term */
    if (!LPM) on(D, 'submit', sf(function (ev) {
      var f = ev.target, t = T();
      if (!REC || !mt(f, 'form[action*="/search"]') || t - lastSS < 1500) return;
      NT++; lastSS = t; lastTapT = t; if (TTFT < 0) TTFT = t;
      if (TAPS.length < 50) TAPS.push({ l: 'search_submit', s: secOf(f), i: 0, v: '', t: t, k: 'ok' });
      lastNav = { l: 'search_submit', t: t };
    }), true);
    if (W.PointerEvent) {
      on(D, 'pointerdown', sf(function (ev) { if (ev.isPrimary !== false) down = { x: ev.clientX, y: ev.clientY, e: ev.target, id: ev.pointerId }; }), { capture: true, passive: true });
      on(D, 'pointercancel', function () { down = null; }, { capture: true, passive: true });
      on(D, 'pointerup', sf(function (ev) {
        var d = down; down = null;
        if (!d || d.id !== ev.pointerId) return;
        var dx = ev.clientX - d.x, dy = ev.clientY - d.y;
        if (Math.abs(dx) < 12 && Math.abs(dy) < 12) tap(d.e, ev.clientX, ev.clientY, 0);
        else if (Math.abs(dx) > 30 && Math.abs(dx) > 1.5 * Math.abs(dy)) {
          if (cl(d.e, '.hgn-card__media,.card__media')) tap(d.e, 0, 0, 1);
          else if (!LPM && cl(d.e, 'media-gallery')) tap(d.e, 0, 0, 2);
        }
      }), { capture: true, passive: true });
    } else {
      on(D, 'click', sf(function (ev) { tap(ev.target, ev.clientX, ev.clientY, 0); }), { capture: true, passive: true });
    }

    /* ── kit and cart, from the events the page already fires ── */
    on(D, 'hgn:kit-build-mode:change', sf(function (ev) { var d = ev.detail || {}; if (REC && d.to === 'on' && d.from !== 'on') KS = 1; }));
    on(D, 'hgn:kit:change', sf(function (ev) { if (REC && (ev.detail || {}).action === 'add') KP++; }));
    function added(viaNet) {
      var t = T();
      if (!REC || (viaNet && t - lastTapT > 10000)) return;
      if (t - lastAdd > 3000) ATC++;
      lastAdd = t;
    }
    on(D, 'hgn:side-cart:add', sf(function () { added(0); }));
    on(D, 'cart:update', sf(function () { added(0); }));

    /* ── speed ── */
    function po(type, f, o) {
      try {
        if (!W.PerformanceObserver || (PerformanceObserver.supportedEntryTypes || []).indexOf(type) < 0) return 0;
        new PerformanceObserver(sf(function (l) { l.getEntries().forEach(f); })).observe(o || { type: type, buffered: true });
        return 1;
      } catch (e) { return 0; }
    }
    var sw = 0, sv = 0, s1 = 0, s9 = 0;
    function speed() {
      po('largest-contentful-paint', function (e) { LCP = Math.round(e.startTime); });
      if (po('layout-shift', function (e) {
        if (e.hadRecentInput) return;
        if (sw && e.startTime - s9 < 1000 && e.startTime - s1 < 5000) { sv += e.value; } else { sv = e.value; s1 = e.startTime; sw = 1; }
        s9 = e.startTime;
        if (sv > CLS) CLS = sv;
      })) { if (CLS < 0) CLS = 0; }
      var ev = function (e) { if (e.interactionId && e.duration > INP) INP = Math.round(e.duration); };
      po('event', ev, { type: 'event', buffered: true, durationThreshold: 16 });
      po('resource', function (e) { if (/\/cart\/add/.test(e.name)) added(1); }, { type: 'resource' });
    }

    /* ── transport: the whole state, rising seq, ≤8 KB, beacon then keepalive fetch, silent on any failure ── */
    function exitNow() {
      var e = null;
      try { e = D.elementFromPoint((W.innerWidth || 0) / 2, (W.innerHeight || 0) / 2); } catch (x) {}
      EXIT = e ? secOf(e) : 'none';
      OUT = lastNav && T() - lastNav.t <= 5000 ? lastNav.l : 'none';
    }
    /* "changed since the last send" (off the landing): what a row would show, not the clock */
    function sig() {
      var n = 0, k;
      for (k in SEC) n++;
      return [NT, TAPS.map(function (t) { return t.k.charAt(0); }).join(''), n, SCR, MAXY, TILES, KS, KP, ATC, LCP, CLS < 0 ? -1 : Math.round(CLS * 1000), INP].join();
    }
    function send(fin) {
      if (!REC || GONE || SENDS >= 240 || (LPM && (!EXP || !KEY)) || !ok()) return;
      var id = ids();
      if (!id.idk) return;
      SEQ++; SENDS++;
      var o = { v: 1, pv: PV, seq: SEQ, final: fin ? 1 : 0, idk: id.idk, cid: id.cid, sc: id.sc, wd: N.webdriver ? 1 : 0, pin: PIN };
      if (LPM) { o.exp = EXP; o.arm = ARM; o.variant = KEY; o.coll = COLL; } else if (COLL) o.coll = COLL;
      o.page = PAGE;
      if (!LPM) { if (HANDLE) o.handle = HANDLE; if (TPL) o.tpl = TPL; LASTSIG = sig(); }
      o.vw = Math.round(W.innerWidth || 0); o.vh = Math.round(W.innerHeight || 0); o.iab = IAB; o.os = OS; o.c0 = C0; o.sec = SEC; o.scroll = SCR;
      o.maxy = MAXY; o.tiles = TILES; o.taps = TAPS.slice(0, 50); o.nt = NT; o.ttft = TTFT; o.top = Math.round(TOP); o.exit = EXIT; o.out = OUT;
      o.kit = { s: KS, p: KP }; o.atc = ATC; o.lcp = LCP; o.cls = CLS < 0 ? -1 : Math.round(CLS * 1000); o.inp = INP;
      var s = JSON.stringify(o);
      while (s.length > 8000 && o.taps.length) { o.taps = o.taps.slice(0, o.taps.length - 5); s = JSON.stringify(o); }
      try { if (N.sendBeacon && N.sendBeacon(EP, new Blob([s], { type: 'text/plain' }))) return; } catch (e) {}
      try { W.fetch(EP, { method: 'POST', body: s, keepalive: true, mode: 'no-cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' } })['catch'](function () {}); } catch (e) {}
    }
    function loop() {
      clearInterval(tickT); clearInterval(sendT);
      if (!visible || !REC) return;
      tickT = setInterval(tick, 1000);
      sendT = setInterval(sf(function () { tick(); if (LPM || sig() !== LASTSIG) send(0); }), EVERY);
      if (!early) { early = 1; setTimeout(sf(function () { if (visible && SEQ === 0) { tick(); send(0); } }), Math.min(5000, EVERY)); }
    }
    var hide = sf(function (fin) { tick(); if (REC) { exitNow(); send(fin); } });

    /* ── start: consent given (and, off the landing, in the sample) ── */
    function start(byEvent) {
      if (REC) return;
      tick();
      REC = 1;
      C0 = byEvent ? T() : 0;
      clearInterval(pollT);
      if (!LPM && !PIN) try { if (/^harness-/.test(W.localStorage.getItem('hgn:did') || '')) PIN = 1; } catch (e) {}
      try {
        io = new IntersectionObserver(sf(function (es) { es.forEach(function (x) { x.target.__hgnJ = x.isIntersecting ? 1 : 0; }); onScroll(); }), { threshold: [0, 0.5, 1] });
        tio = new IntersectionObserver(sf(function (es) {
          es.forEach(function (x) { if (x.isIntersecting && x.intersectionRatio >= 0.5 && mt(x.target, TILE)) { var n = nth(x.target, TILE); if (n > TILES) TILES = n; } });
        }), { threshold: [0.5] });
      } catch (e) { io = tio = null; }
      /* off the landing the first measure waits a frame: reading layout before the browser's own first layout would
         force the whole page's layout inside this task (25-45 ms on the live pages offline; this script's own work is
         ~5 ms). The landing measures at once, as hgn-lp-recorder.js does (its early scroll % depends on it: parity). */
      var went = 0, go = sf(function () {
        if (went) return;
        went = 1;
        sf(scan)();
        tick();
        sf(speed)();
        on(W, 'scroll', onScroll, { passive: true });
        loop();
      });
      if (LPM) return go();
      try { W.requestAnimationFrame(function () { setTimeout(go, 0); }); } catch (e) {}
      setTimeout(go, 500); /* a page loaded in the background gets no frame */
    }
    on(D, 'visibilitychange', sf(function () {
      if (GONE) return;
      if (D.visibilityState === 'hidden') { hide(0); visible = false; loop(); }
      else { lastT = T(); visible = true; loop(); }
    }));
    on(W, 'pagehide', sf(function () { hide(1); GONE = 1; visible = false; loop(); }));
    on(W, 'pageshow', sf(function (ev) { if (ev.persisted) { GONE = 0; lastT = T(); visible = D.visibilityState !== 'hidden'; loop(); } }));
    gate(0);
  }
  try { main(); } catch (e) {}
})(window, document);
